import { useSelector } from "react-redux";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { profileButtons } from "./profileButtons";
import { ArrowIcon } from "../../../assets/icons";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { clearAuthSession } from "../../../utils/authStorage";
import { Spring } from "../../../components/spring/spring";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { Link } from "react-router";
import { EditableAdminInfo } from "../../../components/editableAdminInfo/editableAdminInfo";

import styles from "./profilePage.module.css";

export const SuperAdminProfilePage = () => {
    const openPage = useOpenPage();
    const { isUser, isAdmin } = useSelector(state => state.status);
    const cafeId = useSelector(state => state.user.userData?.cafeId);

    const navigate = useAnimatedNavigate();
    const handleLogout = () => {
        clearAuthSession();
        navigate("/auth/login");
    };

    const [Popup, open] = useConfirmPopup(
        "Вы уверены, что хотите выйти?",
        "Все несохраненные данные будут потеряны",
        handleLogout
    );

    return (
        <>
            <EditableAdminInfo />

            <div className={styles.profile_buttons}>
                {
                    isAdmin &&
                    <Button
                        type="secondary"
                        icon={<ArrowIcon />}
                        text="Панель админа"
                        onClick={openPage("/admin")}
                    />
                }

                {
                    isUser && cafeId !== null &&
                    <Button
                        type="secondary"
                        icon={<ArrowIcon />}
                        text="Панель пользователя"
                        onClick={openPage("/")}
                    />
                }

                {
                    profileButtons
                        .map((data, i) =>
                            <Button
                                key={i}
                                text={data.text}
                                type={data.type}
                                icon={data.icon}
                                onClick={openPage(data.path)}
                            />
                        )
                }
            </div>

            <Spring />

            <Button
                text="Выйти"
                type="semi_destructive"
                onClick={open}
            />

            <Link to="documents" className={styles.documents} viewTransition>Пользовательское соглашение и политика конфиденциальности</Link>

            {Popup}
        </>
    );
};